//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { validateDate } from "@/utils/validations.js";
import BackendServices from "@/services/backend-services.js";

export default {
  name: "LogisticsTab",
  props: ["value"],
  components: {},
  mounted: function () {
    this.validateData();
    BackendServices.getVolumeMeasurementUnits().then(
      ({ data }) => (this.volumeUnits = data)
    );
    BackendServices.getWeigthMeasurementUnits().then(
      ({ data }) => (this.weightUnits = data)
    );
  },
  data: function () {
    return {
      validForm: false,
      weightUnits: [],
      volumeUnits: [],
    };
  },
  methods: {
    required,
    noValidation,
    validateDate,
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
          this.updateData();
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
          this.updateData();
        }
      });
    },
    updateData() {
      this.$emit("value", this.value);
    },
  },
  computed: {
    boxesPerPallet() {
      return this.value.packages_layers * this.value.boxes_in_layers;
    },
    unitsPerPallet() {
      return (
        this.value.packages_layers *
        this.value.boxes_in_layers *
        this.value.box_unit_number
      );
    },
  },
};
